﻿import { IBinder, IValueBinding, ICellBinding } from "./ibinder"
import $ from 'jquery';
import ko from 'knockout';
import Utility from "../utility"

export class ColumnTotalBinder implements IBinder {
  public getElements(root: JQuery): JQuery {
    return root.find("tfoot tr td[data-et-total]");
  }

  public getBinding(element: JQuery, data): IValueBinding {
    var columnNumber: any = element.attr("data-et-total");
    var cellName = "ColumnTotal" + columnNumber;
    var targetCell = element.parents("table").find("tbody tr").eq(0).find("td").eq(columnNumber);
    var valueName = "";
    if (targetCell.data("et-expression-key"))
      valueName = targetCell.data("et-expression-key");
    else
      throw new Error("Not yet implemented: other methods for determining valueName");

    var compute = (d) => ko.computed({
      read: () => {
        var total = 0;
        for (var i = 0, len = d.Rows().length; i < len; i++) {
          total += parseFloat(d.Rows()[i][valueName]().replace(',', ''));
        }
        return Utility.formatTextIfNumber(total);
      }
    }, d);

    return {
      bindingName: "text",
      bindTo: cellName,
      dataName: cellName,
      dataValue: compute(data)
    }
  }
}